import axiosInstance from "@/utils/axiosInstance";

const baseUrl = `api/logs`;

const state = {};

const getters = {};

const mutations = {};

const actions = {
  getLogs({commit}, payload: {query: object}) {
    return axiosInstance.get(`${baseUrl}`, {params: payload?.query})
      .then((data) => data.data);
  },
  getTypes({commit}, payload: {query: object}) {
    return axiosInstance.get(`${baseUrl}/types`, {params: payload?.query})
    .then((data) => data.data);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
